export enum Role {
  Vendor = 'Vendor',
  Customer = "Customer",
  Guest="Guest",
  SiteAdministrator="SiteAdministrator",
  SuperAdministrator='SuperAdministrator',
  WholeSaler='WholeSaler',
  BusinessCustomer='BusinessCustomer'
}


